/* The floating measure tool — distance and bearing between two arbitrary
 * points. M5.11's floating half; the centred (from-the-boat) half is not
 * built.
 *
 * Not persisted, unlike the mark. A measurement is a question about the
 * chart right now — "how far is it across that channel" — not a place worth
 * remembering after the tab closes.
 */

export interface MeasurePos {
  lat: number;
  lon: number;
}

class MeasureTool {
  active = $state(false);
  a = $state<MeasurePos | null>(null);
  b = $state<MeasurePos | null>(null);

  toggle(): void {
    this.active = !this.active;
    if (!this.active) this.clear();
  }

  off(): void {
    this.active = false;
    this.clear();
  }

  /**
   * A tap on the chart while measuring. The first tap sets A; the second
   * sets B and the line appears; a third starts over from that point —
   * Raymarine's rule for this tool, and the one a plotter user already
   * knows rather than one this app invents.
   */
  tap(p: MeasurePos): void {
    if (!this.a || this.b) {
      this.a = p;
      this.b = null;
    } else {
      this.b = p;
    }
  }

  clear(): void {
    this.a = null;
    this.b = null;
  }
}

export const measure = new MeasureTool();
